module.exports = __webpack_public_path__ + "img/finland-cardiovascular-diseases-female.9eb96aa4.png";